<template lang="html">
  <div class="wcc buttons">
    <Button :color="'white'" v-if="calculatorData.compared && calculatorData.collapsed" value="Edit" v-hammer:tap="edit"></Button>
    <Button :color="'white'" v-if="calculatorData.compared && !calculatorData.collapsed" value="Collapse" v-hammer:tap="collapse"></Button>
    <Button :color="'white'" v-if="!calculatorData.compared" value="Compare" v-hammer:tap="compare"></Button>
    <Button :color="'white'" v-if="$store.state.online" :active="calculatorData.emailShow" value="Email" v-hammer:tap="toggleEmail"></Button>
  </div>
</template>
<script>
  import Button from '@/components/Button.vue'

  export default {
    props: ['calculatorData'],
    methods: {
      edit($event) {
        this.$store.dispatch('edit', this.calculatorData)
        $event.target.blur()
      },
      collapse($event) {
        this.$store.dispatch('collapse', this.calculatorData)
        $event.target.blur()
      },
      compare($event) {
        this.$store.dispatch('compare', this.calculatorData)
        $event.target.blur()
      },
      toggleEmail($event) {
        let vm = this
        vm.$store.dispatch('auth/extendSession').then(() => {
          vm.calculatorData.emailShow = !vm.calculatorData.emailShow
          $event.target.blur()
        })
      }
    },
    components: {
      Button
    }
  }
</script>
<style lang="scss">
</style>